export default "__VITE_ASSET__BBz82nEE__"